import React from "react";

export const SingleFilter = ({ filterStatus, value, onChange, disabled }) => {
    const isSelected = value?.indexOf(filterStatus) > -1;
    return (
        <div
            className={`my-cases-filters__simple-item ${isSelected ? "selected" : ""}  ${disabled ? "disabled" : ""}`}
            onClick={() => {
                if (disabled) return;

                if (isSelected) {
                    const valueWithoutChoice = value.filter(x => x !== filterStatus);
                    onChange(valueWithoutChoice);
                } else {
                    onChange([...value, filterStatus]);
                }
            }}
        >
            <div className={`my-cases-filters__simple-item-text ${disabled ? "disabled" : ""}`}>{filterStatus}</div>
        </div>
    );
};
